import { createClient } from '@supabase/supabase-js';

// Falls back to placeholder values so createClient never throws when env vars
// are not yet configured. Auth calls will simply fail with network errors.
const url = import.meta.env.VITE_SUPABASE_URL ?? 'https://placeholder.supabase.co';
const key = import.meta.env.VITE_SUPABASE_ANON_KEY ?? 'placeholder';

export const supabase = createClient(url, key, {
  auth: {
    flowType: 'pkce',
    detectSessionInUrl: false,
    autoRefreshToken: true,
    persistSession: true,
  },
});

export function getAppUrl(): string {
  return import.meta.env.VITE_APP_URL || window.location.origin;
}
